import { render } from "./VisitorFirebaseNotifier.vue?vue&type=template&id=b9d5c9c6"
import script from "./VisitorFirebaseNotifier.vue?vue&type=script&lang=js"
export * from "./VisitorFirebaseNotifier.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__